/* ============================================================
   SPORTIVE COLLECTION - LOAD MORE
   Fetches next page and appends products to grid
   ============================================================ */

(function () {
  'use strict';

  function initLoadMore() {
    const btn = document.getElementById('sportive-load-more-btn');
    if (!btn) return;

    const grid = document.getElementById('sportive-product-grid');
    const countEl = document.getElementById('sportive-load-more-count');
    const progressBar = document.getElementById('sportive-load-more-progress');

    let nextUrl = btn.dataset.nextUrl;
    const totalProducts = parseInt(btn.dataset.total, 10) || 0;
    let loadedCount = parseInt(btn.dataset.loaded, 10) || 0;

    function updateProgress() {
      if (progressBar) {
        const pct = Math.min((loadedCount / totalProducts) * 100, 100);
        progressBar.style.width = pct + '%';
      }
      if (countEl) {
        const remaining = totalProducts - loadedCount;
        countEl.textContent = 'Showing ' + loadedCount + ' of ' + totalProducts + ' products';
      }
      if (loadedCount >= totalProducts) {
        btn.closest('.sportive-load-more').style.display = 'none';
      }
    }

    btn.addEventListener('click', function () {
      if (!nextUrl || btn.disabled) return;

      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.textContent = 'Loading...';

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Get new product items
          const newItems = doc.querySelectorAll('#sportive-product-grid .grid__item');
          newItems.forEach(function (item) {
            grid.appendChild(item.cloneNode(true));
          });

          loadedCount += newItems.length;

          // Get next page URL from the fetched page
          const newBtn = doc.getElementById('sportive-load-more-btn');
          if (newBtn && newBtn.dataset.nextUrl) {
            nextUrl = newBtn.dataset.nextUrl;
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.textContent = 'Load More';
          } else {
            nextUrl = null;
            btn.closest('.sportive-load-more').style.display = 'none';
          }

          updateProgress();

          // Update URL without reload
          const newPage = new URL(nextUrl || window.location.href, window.location.origin);
          const currentPage = new URL(window.location.href);
          if (newBtn) {
            const prevPageNum = parseInt(newPage.searchParams.get('page') || '2', 10) - 1;
            currentPage.searchParams.set('page', prevPageNum);
          }
          history.replaceState({}, '', currentPage.toString());
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.textContent = 'Load More';
        });
    });

    updateProgress();
  }

  document.addEventListener('DOMContentLoaded', initLoadMore);

  /* ----------------------------------------------------------
     SIZE CHIPS — sort ascending, show middle window, ... on each side
     ---------------------------------------------------------- */
  function initSizeChips() {
    document.querySelectorAll('.sportive-card-sizes').forEach(function (container) {
      var limit = 6;
      var chips = Array.from(container.querySelectorAll('.sportive-card-size'));
      if (!chips.length) return;

      // Sort ascending (small → large)
      chips.sort(function (a, b) {
        return parseFloat(a.textContent) - parseFloat(b.textContent);
      });

      chips.forEach(function (chip) { container.appendChild(chip); });

      var total = chips.length;
      if (total <= limit) return;

      // Pick middle window of `limit` sizes
      var startIdx = Math.floor((total - limit) / 2);
      var endIdx = startIdx + limit;

      chips.forEach(function (chip, i) {
        if (i < startIdx || i >= endIdx) chip.style.display = 'none';
      });

      // "..." before window if smaller sizes are hidden
      if (startIdx > 0) {
        var leftDot = document.createElement('span');
        leftDot.className = 'sportive-card-size sportive-card-size--more';
        leftDot.textContent = '...';
        container.insertBefore(leftDot, chips[startIdx]);
      }

      // "..." after window if larger sizes are hidden
      if (endIdx < total) {
        var rightDot = document.createElement('span');
        rightDot.className = 'sportive-card-size sportive-card-size--more';
        rightDot.textContent = '...';
        container.appendChild(rightDot);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initSizeChips);

  /* ----------------------------------------------------------
     AUTO APPLY IN-STOCK FILTER
     On fresh collection visits, pre-select "In Stock".
     Remembers if user manually unchecks it (per session, per collection).
     ---------------------------------------------------------- */
  (function () {
    var OPTOUT_PREFIX = 'sportive_instock_optout';

    function collectionPath() {
      var p = window.location.pathname;
      return p.startsWith('/collections/') && p !== '/collections' ? p : null;
    }

    function hasFilterParams() {
      var params = new URLSearchParams(window.location.search);
      for (var key of params.keys()) {
        if (key.startsWith('filter.')) return true;
      }
      return false;
    }

    function hasAvailability() {
      return new URLSearchParams(window.location.search).get('filter.v.availability') === '1';
    }

    function optOutKey() {
      return OPTOUT_PREFIX + '_' + collectionPath();
    }

    // Intercept pushState to detect when user removes the availability filter
    var _push = history.pushState.bind(history);
    history.pushState = function (state, title, url) {
      var hadAvailability = hasAvailability();
      _push(state, title, url);
      var nowHas = new URLSearchParams(window.location.search).get('filter.v.availability') === '1';
      if (hadAvailability && !nowHas && collectionPath()) {
        sessionStorage.setItem(optOutKey(), '1');
      }
      if (!hadAvailability && nowHas && collectionPath()) {
        sessionStorage.removeItem(optOutKey());
      }
    };

    // On load: redirect to add In Stock if not already set and user hasn't opted out
    var path = collectionPath();
    if (path && !hasFilterParams() && !sessionStorage.getItem(optOutKey())) {
      var url = new URL(window.location.href);
      url.searchParams.set('filter.v.availability', '1');
      window.location.replace(url.toString());
    }
  }());

})();
